// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================================= */
/* ===== ESTILOS DE ESCRITORIO (INTACTOS) ===== */
/* ======================================= */
.Hero_heroSection__gqf-Z {
  background-color: #000000;
  position: relative;
  overflow: hidden;
  padding: 2%;
  padding-top: 0;
}

.Hero_heroContainer__fMQGa {
  margin: 0 auto;
  min-height: calc(100dvh - 100px);
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  gap: 100px;
  position: relative; 
  z-index: 5;
}

.Hero_heroParticles__0Cx\\+5, .Hero_heroWorld__VAyB6 {
  position: absolute;
  z-index: 1;
  pointer-events: none;
}

.Hero_heroParticles__0Cx\\+5 {
  width: 100%;
  height: 100%;
  top: 0;
  right: -680px;
  object-fit: fill;
  opacity: 1;
}

.Hero_heroWorld__VAyB6 {
  width: 400px;
  height: 400px;
  top: 65%;
  left: -150px;
  transform: translateY(-50%);
  opacity: 0.6;
}

.Hero_heroContent__YokLE {
  text-align: left;
  width: auto;
  left: 100px;
}

.Hero_heroContent__YokLE h1 {
  font-size: 80px;
  font-weight: 800;
  color: var(--textoBlanco);
  line-height: 1.1;
}

.Hero_heroContent__YokLE h1 span {
  font-size: 80px;
  font-weight: bold;
  color: #FF3B00;
}

.Hero_heroContent__YokLE p {
  font-size: 18px;
  color: #d0d0d0;
  margin: 25px 0 40px 0;
  line-height: 1.7;
  max-width: 500px;
  align-items: center;
}

.Hero_ctaButton__rkjg1 {
  background-color: var(--naranja);
  color: var(--textoBlanco);
  padding: 15px 35px;
  border-radius: 5px;
  font-weight: bold;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.Hero_ctaButton__rkjg1:hover {
  background-color: var(--azul);
  transform: translateY(-3px);
  box-shadow: 0 4px 10px rgba(2, 171, 231, 0.3);
}

.Hero_heroRobotContainer__VP8Ea {
  position: relative;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Hero_heroRobot__EMBBq {
  max-width: 420px;
  width: 100%;
  animation: Hero_float__33PqD 6s ease-in-out infinite;
 
}

@keyframes Hero_float__33PqD {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
}

.Hero_partnersSection__vfaln {
  background-color: var(--azul);
  padding: 80px 5%;
}

.Hero_logosContainer__LMB2m {
  overflow: hidden;
  width: 100%;
  mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
}

.Hero_logosTrack__OTN6X {
  display: flex;
  width: calc(250px * 10);
  animation: Hero_scrollAnimation__iT-W5 40s linear infinite;
}

.Hero_logo__EVsm\\+ {
  height: 100px;
  width: auto;
  margin: 0 50px;
}

@keyframes Hero_scrollAnimation__iT-W5 {
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
}


/* ======================================================== */
/* ===== MEDIA QUERY PARA MÓVIL (SECCIÓN CORREGIDA) ===== */
/* ======================================================== */
@media (max-width: 767px) {
  .Hero_heroSection__gqf-Z {
    padding: 80px 5% 60px 5%;
  }

  .Hero_heroContainer__fMQGa {
    grid-template-columns: 1fr; /* Una sola columna, como debe ser */
    text-align: center;
    gap: 40px;
    height: 900px;
  }

  .Hero_heroContent__YokLE h1 {
    font-size: 40px; /* Tamaño de fuente legible */
  }

  .Hero_heroContent__YokLE h1 span {
    font-size: 42px; /* Tamaño de fuente del span también ajustado */
  }

  
  /* --- Corrección del contenido de texto --- */
  .Hero_heroContent__YokLE {
    width: 100%;
    text-align: center;
    order: 1; 
    left: 1px;
  }
  
  /* --- Corrección del posicionamiento del robot --- */
  .Hero_heroRobotContainer__VP8Ea {
    order: 1;
    margin-bottom: 20px;
    transform: translate(100%, 50);
    right: -50px;
  }
  
  .Hero_heroRobot__EMBBq {
    max-width: 300px;
  }
  
  .Hero_heroWorld__VAyB6 {
    left: 50%; 
    top: 30%;
    transform: translate(-100%, 50%);
    width: auto; 
    max-width: 500px;
    opacity: 1; 
  }

  .Hero_heroParticles__0Cx\\+5 {
    right: 50%; /* Centramos las partículas */
    top: 30%;
    transform: translate(50%, -50%);
    width: 120%;
    max-width: 500px;
    opacity: 0.8;
  }

  /* --- Ajustes de la sección de partners --- */
  .Hero_partnersSection__vfaln {
    padding: 50px 5%; /* Menos padding vertical */
  }
  .Hero_logo__EVsm\\+ {
    height: 50px;
    margin: 0 30px;
  }
  
  .Hero_logosTrack__OTN6X {
    width: calc(180px * 10);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Hero.module.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C,iDAAiD;AACjD,4CAA4C;AAC5C;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,MAAM;EACN,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oDAAwC;;AAE1C;;AAEA;EACE,KAAK,0BAA0B,EAAE;EACjC,MAAM,4BAA4B,EAAE;EACpC,OAAO,0BAA0B,EAAE;AACrC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EAEX,qFAAqF;AACvF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,0DAA8C;AAChD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,KAAK,2BAA2B,EAAE;AACpC;;;AAGA,6DAA6D;AAC7D,2DAA2D;AAC3D,6DAA6D;AAC7D;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B,EAAE,oCAAoC;IAChE,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe,EAAE,6BAA6B;EAChD;;EAEA;IACE,eAAe,EAAE,+CAA+C;EAClE;;;EAGA,8CAA8C;EAC9C;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;EACX;;EAEA,qDAAqD;EACrD;IACE,QAAQ;IACR,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,UAAU,EAAE,6BAA6B;IACzC,QAAQ;IACR,+BAA+B;IAC/B,WAAW;IACX,gBAAgB;IAChB,YAAY;EACd;;EAEA,8CAA8C;EAC9C;IACE,gBAAgB,EAAE,2BAA2B;EAC/C;EACA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* ======================================= */\n/* ===== ESTILOS DE ESCRITORIO (INTACTOS) ===== */\n/* ======================================= */\n.heroSection {\n  background-color: #000000;\n  position: relative;\n  overflow: hidden;\n  padding: 2%;\n  padding-top: 0;\n}\n\n.heroContainer {\n  margin: 0 auto;\n  min-height: calc(100dvh - 100px);\n  max-width: 100%;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  align-items: center;\n  gap: 100px;\n  position: relative; \n  z-index: 5;\n}\n\n.heroParticles, .heroWorld {\n  position: absolute;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.heroParticles {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  right: -680px;\n  object-fit: fill;\n  opacity: 1;\n}\n\n.heroWorld {\n  width: 400px;\n  height: 400px;\n  top: 65%;\n  left: -150px;\n  transform: translateY(-50%);\n  opacity: 0.6;\n}\n\n.heroContent {\n  text-align: left;\n  width: auto;\n  left: 100px;\n}\n\n.heroContent h1 {\n  font-size: 80px;\n  font-weight: 800;\n  color: var(--textoBlanco);\n  line-height: 1.1;\n}\n\n.heroContent h1 span {\n  font-size: 80px;\n  font-weight: bold;\n  color: #FF3B00;\n}\n\n.heroContent p {\n  font-size: 18px;\n  color: #d0d0d0;\n  margin: 25px 0 40px 0;\n  line-height: 1.7;\n  max-width: 500px;\n  align-items: center;\n}\n\n.ctaButton {\n  background-color: var(--naranja);\n  color: var(--textoBlanco);\n  padding: 15px 35px;\n  border-radius: 5px;\n  font-weight: bold;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.ctaButton:hover {\n  background-color: var(--azul);\n  transform: translateY(-3px);\n  box-shadow: 0 4px 10px rgba(2, 171, 231, 0.3);\n}\n\n.heroRobotContainer {\n  position: relative;\n  z-index: 3;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.heroRobot {\n  max-width: 420px;\n  width: 100%;\n  animation: float 6s ease-in-out infinite;\n \n}\n\n@keyframes float {\n  0% { transform: translateY(0px); }\n  50% { transform: translateY(-20px); }\n  100% { transform: translateY(0px); }\n}\n\n.partnersSection {\n  background-color: var(--azul);\n  padding: 80px 5%;\n}\n\n.logosContainer {\n  overflow: hidden;\n  width: 100%;\n  -webkit-mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);\n  mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);\n}\n\n.logosTrack {\n  display: flex;\n  width: calc(250px * 10);\n  animation: scrollAnimation 40s linear infinite;\n}\n\n.logo {\n  height: 100px;\n  width: auto;\n  margin: 0 50px;\n}\n\n@keyframes scrollAnimation {\n  from { transform: translateX(0); }\n  to { transform: translateX(-50%); }\n}\n\n\n/* ======================================================== */\n/* ===== MEDIA QUERY PARA MÓVIL (SECCIÓN CORREGIDA) ===== */\n/* ======================================================== */\n@media (max-width: 767px) {\n  .heroSection {\n    padding: 80px 5% 60px 5%;\n  }\n\n  .heroContainer {\n    grid-template-columns: 1fr; /* Una sola columna, como debe ser */\n    text-align: center;\n    gap: 40px;\n    height: 900px;\n  }\n\n  .heroContent h1 {\n    font-size: 40px; /* Tamaño de fuente legible */\n  }\n\n  .heroContent h1 span {\n    font-size: 42px; /* Tamaño de fuente del span también ajustado */\n  }\n\n  \n  /* --- Corrección del contenido de texto --- */\n  .heroContent {\n    width: 100%;\n    text-align: center;\n    order: 1; \n    left: 1px;\n  }\n  \n  /* --- Corrección del posicionamiento del robot --- */\n  .heroRobotContainer {\n    order: 1;\n    margin-bottom: 20px;\n    transform: translate(100%, 50);\n    right: -50px;\n  }\n  \n  .heroRobot {\n    max-width: 300px;\n  }\n  \n  .heroWorld {\n    left: 50%; \n    top: 30%;\n    transform: translate(-100%, 50%);\n    width: auto; \n    max-width: 500px;\n    opacity: 1; \n  }\n\n  .heroParticles {\n    right: 50%; /* Centramos las partículas */\n    top: 30%;\n    transform: translate(50%, -50%);\n    width: 120%;\n    max-width: 500px;\n    opacity: 0.8;\n  }\n\n  /* --- Ajustes de la sección de partners --- */\n  .partnersSection {\n    padding: 50px 5%; /* Menos padding vertical */\n  }\n  .logo {\n    height: 50px;\n    margin: 0 30px;\n  }\n  \n  .logosTrack {\n    width: calc(180px * 10);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroSection": `Hero_heroSection__gqf-Z`,
	"heroContainer": `Hero_heroContainer__fMQGa`,
	"heroParticles": `Hero_heroParticles__0Cx+5`,
	"heroWorld": `Hero_heroWorld__VAyB6`,
	"heroContent": `Hero_heroContent__YokLE`,
	"ctaButton": `Hero_ctaButton__rkjg1`,
	"heroRobotContainer": `Hero_heroRobotContainer__VP8Ea`,
	"heroRobot": `Hero_heroRobot__EMBBq`,
	"float": `Hero_float__33PqD`,
	"partnersSection": `Hero_partnersSection__vfaln`,
	"logosContainer": `Hero_logosContainer__LMB2m`,
	"logosTrack": `Hero_logosTrack__OTN6X`,
	"scrollAnimation": `Hero_scrollAnimation__iT-W5`,
	"logo": `Hero_logo__EVsm+`
};
export default ___CSS_LOADER_EXPORT___;
